import { buttonVariants } from "@solomon-apps/shared/src/components/ui/button";
import { Heading } from "@solomon-apps/shared/src/components/ui/heading";
import { ArrowShortLeftIcon } from "@solomon-labs/design/components/icons";
import { motion } from "motion/react";
import React from "react";
import { Link, useParams } from "react-router-dom";

import { InlinePositionEditor } from "./EditPosition/InlinePositionEditor";

/**
 * YaaS Client Console — Edit Position page (standalone route).
 *
 * Wraps `InlinePositionEditor` with page chrome (header, back link).
 * The same editor renders inline on the Dashboard and Positions pages.
 */
export function EditPositionPage(): React.ReactElement {
    const { positionUuid } = useParams<{ positionUuid: string }>();

    if (!positionUuid) {
        return (
            <div className="flex flex-col gap-4 p-6 max-w-[1080px] mx-auto">
                <Heading title="Position not found." titleVariant="h2" />
                <Link
                    to="/"
                    className={buttonVariants({
                        variant: "raised",
                        size: "md"
                    })}
                >
                    Back to dashboard
                </Link>
            </div>
        );
    }

    return (
        <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="flex flex-col w-full py-6"
        >
            <InlinePositionEditor
                positionUuid={positionUuid}
                backLink={
                    <Link
                        to="/positions"
                        className={buttonVariants({
                            variant: "transparent",
                            interaction: "underline",
                            size: "fit"
                        })}
                    >
                        <ArrowShortLeftIcon className="size-3.5 shrink-0" />
                        Back to Positions
                    </Link>
                }
            />
        </motion.div>
    );
}
